// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Comment } from './comment';
import {
    CommentFromJSON,
    CommentFromJSONTyped,
    CommentToJSON,
    CommentToJSONTyped,
} from './comment';

/**
 * 
 * @export
 * @interface CommentsListResponse
 */
export interface CommentsListResponse {
    /**
     * 
     * @type {Array<Comment>}
     * @memberof CommentsListResponse
     */
    comments: Array<Comment>;
    /**
     * 
     * @type {string}
     * @memberof CommentsListResponse
     */
    dta_id: string;
    /**
     * 
     * @type {number}
     * @memberof CommentsListResponse
     */
    total: number;
}

/**
 * Check if a given object implements the CommentsListResponse interface.
 */
export function instanceOfCommentsListResponse(value: object): value is CommentsListResponse {
    if (!('comments' in value) || value['comments'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function CommentsListResponseFromJSON(json: any): CommentsListResponse {
    return CommentsListResponseFromJSONTyped(json, false);
}

export function CommentsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'comments': ((json['comments'] as Array<any>).map(CommentFromJSON)),
        'dta_id': json['dta_id'],
        'total': json['total'],
    };
}

export function CommentsListResponseToJSON(json: any): CommentsListResponse {
    return CommentsListResponseToJSONTyped(json, false);
}

export function CommentsListResponseToJSONTyped(value?: CommentsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comments': ((value['comments'] as Array<any>).map(CommentToJSON)),
        'dta_id': value['dta_id'],
        'total': value['total'],
    };
}
